export default {
  className: 'fitmentBook',
  defaultOrder: '-weight', // 修改默认排序方式，按照权重倒序排列
  fields: [
    {
      name: 'section',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'bookMoney',
      tooltip: '此字段不填或者为0时则代表此章节不收费',
      validators: [
        (value) => value < 0 ? '请填写大于0的章节费用' : ''
      ]
    },
    {
      name: 'bookContent',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    }
  ],
  search: [
    'section'
  ],
  action: {
    export: false,
    sorter: {
      type: 'list',
      icon: 'swap',
      text: '排序',
      component: 'akModelSorter'
    }
  }
}
